export default __webpack_public_path__ + "static/media/contact-light.8bfd1e02.svg";